import { render, staticRenderFns } from "./ProductsSubLineQuickAdd.vue?vue&type=template&id=1a45baea&"
import script from "./ProductsSubLineQuickAdd.vue?vue&type=script&lang=js&"
export * from "./ProductsSubLineQuickAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports